var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13495 11.5481V11.1106C7.13495 10.6093 7.22609 10.1923 7.40839 9.85962C7.59068 9.52694 7.90969 9.18286 8.36542 8.82739C8.90774 8.39901 9.25637 8.06632 9.41132 7.82935C9.57082 7.59237 9.65057 7.30981 9.65057 6.98169C9.65057 6.59888 9.52297 6.30493 9.26776 6.09985C9.01255 5.89478 8.64569 5.79224 8.16718 5.79224C7.73423 5.79224 7.33319 5.85376 6.96405 5.97681C6.59491 6.09985 6.23488 6.24797 5.88397 6.42114L5.30975 5.21802C6.23488 4.70304 7.22609 4.44556 8.28339 4.44556C9.17662 4.44556 9.88527 4.66431 10.4094 5.10181C10.9335 5.53931 11.1955 6.14315 11.1955 6.91333C11.1955 7.25513 11.1454 7.56047 11.0451 7.82935C10.9448 8.09367 10.7922 8.3466 10.5871 8.58813C10.3866 8.82967 10.0379 9.14412 9.5412 9.53149C9.11737 9.86418 8.83254 10.1399 8.68671 10.3586C8.54543 10.5774 8.47479 10.8713 8.47479 11.2405V11.5481H7.13495ZM6.85468 13.7288C6.85468 13.0406 7.18964 12.6965 7.85956 12.6965C8.18768 12.6965 8.43833 12.7877 8.61151 12.97C8.78469 13.1477 8.87128 13.4006 8.87128 13.7288C8.87128 14.0523 8.78241 14.3098 8.60468 14.5012C8.4315 14.6881 8.18313 14.7815 7.85956 14.7815C7.53599 14.7815 7.28762 14.6903 7.11444 14.5081C6.94126 14.3212 6.85468 14.0614 6.85468 13.7288Z",
    fill: "#979797"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25259,
    cy: 9.08322,
    r: 7.60617,
    stroke: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTooltip);
export default __webpack_public_path__ + "static/media/icon-tooltip.872944eb728c6ea33311dd3285befeb3.svg";
export { ForwardRef as ReactComponent };